"use client";

import {
  ComponentSharedDatasourcesLabelsRegionBriefDatasource,
  JapanArea,
  JapanDatasourceTopAttraction,
  RegionListQuery,
} from "@/types/generated";
import { MapBrandIcon } from "@app/[locale]/tourist-attraction/[city_slug]/[slug]/util";
import { DestinationBriefSection } from "./DestinationBriefSection";
import { DestinationTopAttractions } from "./DestinationTopAttractions";

interface DestinationAttractionProps {
  destinationAreaData: JapanArea[];
  topAttractionsDatasource: JapanDatasourceTopAttraction;
  regionName?: string;
  nameArea?: string;
  brandIcons?: MapBrandIcon[];
  regionBriefDatasource?: ComponentSharedDatasourcesLabelsRegionBriefDatasource;
  seeAllAttractions?: string | null;
  title?: string | null;
  regionData?: RegionListQuery;
}
/**
 * DestinationAttraction Component
 * Main container component that displays destination brief and top attractions.
 * Composed of DestinationBriefSection and DestinationTopAttractions.
 */
export const DestinationAttraction = ({
  destinationAreaData,
  topAttractionsDatasource,
  regionName,
  nameArea,
  brandIcons,
  regionBriefDatasource,
  seeAllAttractions,
  title,
  regionData,
}: DestinationAttractionProps) => {
  return (
    <div className="flex flex-col gap-8 space-y-4 py-20 max-md:gap-5 max-md:px-4 max-md:py-5">
      <DestinationBriefSection
        destinationAreaData={destinationAreaData}
        regionName={regionName}
        regionBriefDatasource={regionBriefDatasource}
      />
      <DestinationTopAttractions
        destinationAreaData={destinationAreaData}
        topAttractionsDatasource={topAttractionsDatasource}
        regionName={regionName}
        nameArea={nameArea}
        brandIcons={brandIcons}
        seeAllAttractions={seeAllAttractions}
        title={title}
        regionData={regionData}
      />
    </div>
  );
};
